import './machine_app_popup.css';
import $ from 'jQuery';

const showPopup = (pPopup, pPosition, pFitToScreen = false) => {
  $('.machine_app_popup_container').remove();
  // We need to add the popup to the DOM before getting its width and height
  pPopup.appendTo($('body'));

  let { left, top } = pPosition ? pPosition : { left: 0, top: 0 };
  if (pFitToScreen) {
    const screen = $(window);
    const lPopupMargin = 15;

    // Make sure we don't go off the screen on the left and top
    left = Math.max(left, lPopupMargin);
    top = Math.max(top, lPopupMargin);

    // Make sure we don't go off the screen on the right and bottom
    left = Math.min(left, screen.outerWidth() - pPopup.outerWidth() - lPopupMargin);
    top = Math.min(top, screen.outerHeight() - pPopup.outerHeight() - lPopupMargin);
  }

  pPopup
    .css({
      left: `${left}px`,
      top: `${top}px`
    });

  pPopup.on('click', (pEvent) => {
    pEvent.stopPropagation();
  });
};

const hidePopup = (pPopup) => {
  pPopup.detach();
};

export const popup = (pPopupContent) => {
  const lPopupContainer = $('<div>')
    .addClass('machine_app_popup_container')
    .append(pPopupContent);

  return {
    container: lPopupContainer,
    show: (pPosition) => showPopup(lPopupContainer, pPosition, true ),
    hide: () => hidePopup(lPopupContainer),
  };
};